(function ($) {
  'use strict';

  function mainSlider() {
    var $slideshow = $('.home-slider');
    $slideshow.owlCarousel({
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      mouseDrag: false,
      items: 1,
      margin: 0,
      stagePadding: 0,
      smartSpeed: 450,
      nav: false,
      loop: true,
      lazyContent: true,
      autoplay: true,
      autoplayTimeout: 5000
    });
  }

  function owlSlider() {
    $('.related-products-items.owl-carousel').owlCarousel({
      loop: false,
      margin: 15,
      nav: true,
      dots: false,
      lazyLoad: true,
      responsiveClass: true,

      responsive: {
        0: {
          items: 2,
          margin: 5,
          nav: true
        },
        600: {
          items: 3,
          margin: 10,
          nav: true
        },
        1000: {
          items: 4,
          nav: true
        }
      }
    })

    //Home Product Slider
    $('.home-products__slider').owlCarousel({
      loop: true,
       items: 5,
      margin: 10,
      autoplay: true,
      nav: true,
      dots: true,
      lazyLoad: true,
      responsiveClass: true,

      responsive: {
        0: {
          items: 2,
          nav: false,
          dots: true
        },
        600: {
          items: 3,
          nav: false,
          dots: true
        },
        1000: {
          items: 5,
          nav: false,
          dots: false
        }
      }
    })
    //Home Product Slider
    $('.index-products__slider').owlCarousel({
      loop: true,
       items: 5,
      margin: 10,
      autoplay: true,
      nav: true,
      dots: true,
      lazyLoad: true,
      responsiveClass: true,

      responsive: {
        0: {
          items: 2,
          nav: false,
          dots: true
        },
        600: {
          items: 3,
          nav: false,
          dots: true
        },
        1000: {
          items: 4,
          nav: true,
          dots: false
        }
      }
    })

  }

  function scrollHash() {
    $("a.scroll-hash").on('click', function (event) {

      // Make sure this.hash has a value before overriding default behavior
      if (this.hash !== "") {
        // Prevent default anchor click behavior
        event.preventDefault();

        // Store hash
        var hash = this.hash;

        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        $('html, body').animate({
          scrollTop: $(hash).offset().top - 180
        }, 1000, function () {

          // Add hash (#) to URL when done scrolling (default click behavior)
          //window.location.hash = hash;
        });
      } // End if
    });
  }


 //Sticky Header
   var stickyNav = function () {
    var stickyElement = $(".site-header"),
        stickyClass = "isStuck",
        stickyPos = stickyElement.offset().top, //Distance from the top of the window.
        stickyHeight;

    //Create a negative margin to prevent content 'jumps':
    stickyElement.after('<div class="jumps-prevent"></div>');
    function jumpsPrevent() {
      stickyHeight = stickyElement.innerHeight();
      stickyElement.css({"margin-bottom":"-" + stickyHeight + "px"});
      stickyElement.next().css({"padding-top": + stickyHeight + "px"});
    };
    jumpsPrevent(); //Run.

    //Function trigger:
    $(window).resize(function(){
      jumpsPrevent();
    });

    //Sticker function:
    function stickerFn() {
      var winTop = $(window).scrollTop();
      //Check element position:

      if (stickyPos < 0 && winTop == 0) {
        stickyElement.removeClass(stickyClass);
      } else if (winTop >= stickyPos && winTop != 0){
        stickyElement.addClass(stickyClass);
      } else if (winTop == 0 && stickyPos == 0){
        stickyElement.removeClass(stickyClass);
      } else {
        stickyElement.removeClass(stickyClass);
      }
    };
    stickerFn(); //Run.

    //Function trigger:
    $(window).scroll(function(){
      stickerFn();
    });
   }
   // End Sticky Header

  function searchToggle() {
    var searchContainer = $('#header-search-bar'),
        searchOpen = $('.site-header__search-trigger'),
        searchClose = searchContainer.find('.site-header__search-close');

    searchOpen.click(function(evt){
      evt.preventDefault();

      if (searchContainer.hasClass('active')) {
        searchContainer.removeClass('active');
      } else {
        searchContainer.addClass('active');
        setTimeout(function(){
        searchContainer.find('input#search-bar__input').focus();
        }, 500);
      }
    })

    searchClose.click(function () {
      searchContainer.removeClass('active');
    });
  }

  $(document).ready(function () {
    searchToggle();
    scrollHash();
    owlSlider();
    mainSlider();
  
    stickyNav();

       //Blog banner
    $('.featured-blog__banner').owlCarousel({
      loop: true,
       items: 1,
      margin: 0,
      autoplay: false,
      nav: true,
      dots: false,
      lazyLoad: false
    })
        $('.featured-blog__taged').owlCarousel({
      loop: true,
       items: 1,
      margin: 0,
      autoplay: false,
      nav: true,
      dots: false,
      lazyLoad: false
    })

    lazySizes.init();


//     $('.site-nav--has-dropdown.mega-menu > a').click(function (e) {
//       e.preventDefault();
//       var $this = $(this).parent(),
//           $navOverlay = $('#NavOverlay');
//       $this.siblings().removeClass('dropdown--active');
//       $navOverlay.removeClass('nav-overlay--active');
//       if ($this.hasClass('dropdown--active')) {
//         $navOverlay.removeClass('nav-overlay--active');
//         $this.removeClass('dropdown--active').parents('.site-header').removeClass('header--active');
//       } else {
//         $navOverlay.addClass('nav-overlay--active');
//         $this.addClass('dropdown--active').parents('.site-header').addClass('header--active');
//       }

//     });

//     $('#NavOverlay').click(function () {
//       var $this = $(this);
//       $this.removeClass('nav-overlay--active');
//       $('.site-nav--has-dropdown').removeClass('dropdown--active').parents('.site-header').removeClass('header--active');
//     });

  });

  $(window).load(function () {
    //$('body').css('opacity', '1');
    $('.cart-item__qty .js-qty__adjust').click(function () {
      $('.update-cart').trigger('click');
      console.log('clicked update');
    });
  });
})(jQuery);



      $(document).ready(function(){
            $('.collection-toolbar__wrapper').stickUp({
              topMargin: "60px",
              zIndex: 101,
      disableOn : function(){
        if( $(window).width() > 768 )
          return false;
        return true;
      }
    });
  function addToCartSuccess(formid){
    $.getJSON('/cart.js', function(cart){ 
      $('.cart-nav-link .cart-count').show();
      $('.cart-nav-link .cart-count span').text(cart.item_count);
      renderHoverCart(cart);
    }).done(function( data ) {
      $('.emptyCart').remove();
     // $('.cart-nav-link').trigger('click');
      $('.mini-cart').show();
      $('#NavOverlay').addClass('nav-overlay--active');
      $('body').addClass('fixed');
      $('#crt,#crt-mb').addClass('has-item');
      $('#'+formid).find('.add-to-cart-msg').hide().addClass('success').html('Item added to cart! <a href="/cart" title="view Cart">View cart and check out &raquo;</a>').fadeIn().delay(3000).fadeOut();

      setTimeout(function(){ 
        $('.mini-cart').hide();
        $('#NavOverlay').removeClass('nav-overlay--active');
        $('body').removeClass('fixed');
      }, 5000);
    });
  }
  function renderHoverCart(cart) {
    var mf = null;
    var source = $("#cartTemplate").html();
    var template = Handlebars.compile(source);
    var items = [];
    var data = {};
    $.each(cart.items, function(i,o){
      var ps = o.variant_title;

      items.push({
        id: o.id,
        vendor: o.vendor,
        title: o.product_title,
        url: o.url,
        quantity: o.quantity,
        properties : ps,
        price: Shopify.formatMoney(o.price,mf),
        image: Shopify.resizeImage(o.image,'small'),
        line: i+1
      });
    });
        data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price,mf),
    }
    $("#crt,#crt-mb").html( template(data) );
  }
  $('.cart-nav-link').hover(function(e){
    e.preventDefault();
    var a = $(this).parent().find('.mini-cart');
    $('.mini-cart').not($(a)).hide();
    $(this).parent().find('.mini-cart').show();
    $('#NavOverlay').addClass('nav-overlay--active');
    $('body').addClass('fixed');
  });

  window.onclick = function(e) {
    if (!$(e.target).closest('.cart-hover-link').length){
      $('.mini-cart').hide();
      $('#NavOverlay').removeClass('nav-overlay--active');
      $('body').removeClass('fixed');
    }
  }
  
//   $(".mini-cart").mouseleave(function(){
//     $(this).hide();
//     $('#NavOverlay').removeClass('nav-overlay--active');
// });

        $('#AddToCart,#QuickViewAdd').click(function(e){
          e.preventDefault();
          var btn = $(this);
          btn.find('span').html('<svg class="icon" enable-background="new 0 0 576 576" viewBox="0 0 576 576" xmlns="http://www.w3.org/2000/svg"><g fill="#fff"><circle cx="131" cy="288" r="31.5"/><circle cx="445.5" cy="287.5" opacity=".5" r="31.5"/><circle cx="340.5" cy="287.5" r="31.5"/><circle cx="235.5" cy="287.5" r="31.5"/></g></svg>');
          var form      = $(this).closest('form');
          var formid = $(this).closest('form').attr('id');

          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: form.serialize(),
            dataType: 'json',
            error: function(jqXHR, textStatus, errorThrown){
              var response = $.parseJSON(jqXHR.responseText);
              $('#AddToCartForm .product-single__controls').append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
                          setTimeout(function(){ 
                            $('p.error').remove();
            }, 5000);
              btn.find('span').text('Add to shopping bag');
         
            }
          }).done(function( data ) {
            addToCartSuccess(formid);

            btn.find('span').html('<svg class="icon-checked" enable-background="new 0 0 576 576" viewBox="0 0 576 576" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="4"><circle cx="277.5" cy="287.5" r="136.5"/><path d="m187.6 310.4 71 55.2 102.5-157"/></g></svg>');
            $('html, body').animate({
              scrollTop:  0
            }, 1000, function () {

              // Add hash (#) to URL when done scrolling (default click behavior)
              //window.location.hash = hash;
            });
            setTimeout(function(){ 
              btn.find('span').text('Added to shopping bag');
            }, 1000);
          });
        });
        $("#crt,#crt-mb").on('click', "a.remove_item", function(r){
          // r.preventDefault();
          var id = $(this).data("id");
          Shopify.changeItem(id,0, function(c){
            $('.cart-nav-link .cart-count span').text(c.item_count);
            if(!c.item_count) {
              $('#crt,#crt-mb').empty();
              $('#crt,#crt-mb').append('<p class="emptyCart">You have no items in your shopping bag.</p>');
              $('#crt,#crt-mb').removeClass('has-item');
            } else {
              renderHoverCart(c);
            }
          });
        });

      });


  var menu = new MmenuLight(
    document.querySelector( '#mmenu' ),
    'all'
  );

  var navigator = menu.navigation({
    // selectedClass: 'Selected',
    // slidingSubmenus: true,
    // theme: 'dark',
    // title: 'Menu'
  });

  var drawer = menu.offcanvas({
    // position: 'left'
  });

  //	Open the menu.
  document.querySelector( 'a[href="#mmenu"]' )
  .addEventListener( 'click', evnt => {
    evnt.preventDefault();
    drawer.open();
  });
  $('#mmenu.mm-spn--main').after().click(function () {
    drawer.close();
});